/**
 * BrowserCheckService class provides functionality to check if the current browser is supported based on a configuration.
 */
class BrowserCheckService {
    /**
     * Constructs a new BrowserCheckService instance.
     * @param {Object} $config - The configuration object containing supported browser list.
     */
    constructor($config) {
        // 'ngInject'; // Remove this line if present
        this.config = $config;
        this._supportedBrowser = $config.getSupportedBrowserList();
    }

    /**
     * Retrieves the current browser and its version from the user agent string.
     * @returns {string} The browser name and version.
     */
    getBrowserVersion() {
        var ua = navigator.userAgent, tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) return 'Opera ' + tem[1];
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    }

    /**
     * Checks if the current browser is supported based on the configuration.
     * @returns {boolean} True if the browser is supported, otherwise false.
     */
    isSupported() {
        var browser = this.getBrowserVersion().split(' ');

        var browser_name = browser[0].toLowerCase();
        var browser_version = parseInt(browser[1]);

        if (browser_name && browser_version) {
            if (this._supportedBrowser[browser_name] && this._supportedBrowser[browser_name] <= browser_version) {
                return true;
            }
        }

        return false;
    }
}

// Add explicit dependency injection
BrowserCheckService.$inject = ['$config'];

export default BrowserCheckService;